export interface NormalizedEui {
  value: string;
  valid: boolean;
}

export function normalizeGatewayEui(raw: string): NormalizedEui {
  const value = (raw ?? '').replace(/[:\-\s]/g, '').toUpperCase();
  const valid = /^[0-9A-F]{16}$/.test(value);
  return { value, valid };
}
